import adel from "../assets/music/ad.mp3";
import taylor from "../assets/music/agust.mp3";
import selena from "../assets/music/selenagomez.mp3";
import Amplitude from "myamplitudejs";
export const initAmplitude = () => {
  Amplitude.init({
    waveforms: {
      sample_rate: 3000,
    },
    songs: [],
    debug: true,
    callbacks: {
      progress: function (e, v) {
        console.log("callback", e, v);
      },
      playlist_changed: function () {
        console.log("Playlist changed");
      },
      ended: function () {
        alert("finished");
      },
    },
  });
  Amplitude.setDebug(true);
};
export const addSong = (songObj) => {
  if (Amplitude.getConfig().songs.length === 0) {
    console.log("amp if", Amplitude.getConfig());
    Amplitude.addSong(songObj);
    console.log("amp if aftere addSong", window.Amplitude.getConfig());
    Amplitude.playNow(songObj);
    Amplitude.bindNewElements();
  } else {
    console.log("amp else", Amplitude.getConfig());

    Amplitude.addSong(songObj);
  }
  Amplitude.bindNewElements();
};
export const bindElements = () => {
  Amplitude.bindNewElements();
};
export const getPlayerState = () => {
  return Amplitude.getPlayerState();
};
export const playNow = (song) => {
  Amplitude.playNow(song);
  Amplitude.getConfig().active_playlist = undefined; // reset current playlist to undefined when play an individual song to disable next and prev button
};
export const pause = () => {
  Amplitude.pause();
};
export const resume = () => {
  Amplitude.play();
};
//playlist utils
export const addPlaylist = (key, data, songs) => {
  Amplitude.addPlaylist(key, data, songs);
};
export const addSongToPlaylist = (songObject, playlistKey) => {
  Amplitude.addSongToPlaylist(songObject, playlistKey);
};
export const playPlaylistSongAtIndex = (playlistIndex, playlistKey) => {
  Amplitude.playPlaylistSongAtIndex(playlistIndex, playlistKey);
};
